/**
 * "Compre o conjunto" da PDP (bloco compre_junto em main-product).
 *
 * O Liquid ja traz as pecas do metacampo custom.compre_junto. Se ficarem menos
 * de `data-limit`, completa com o Search & Discovery: primeiro as
 * complementares, depois as relacionadas (que sao algoritmicas e sempre
 * devolvem algo), sem repetir peca. Sem nada no fim, o bloco some.
 * O "Adicionar" e o .m-product-quickview-button do tema, entao o quick view
 * abre sozinho por delegacao de evento.
 *
 * Origem da venda: a peca comprada pelo quick view que o bloco abriu vai para o
 * carrinho com a propriedade oculta _origem = "Compre o conjunto" (comeca com
 * "_", entao gaveta, carrinho e checkout nao mostram). Fica gravada no pedido,
 * e e por ela que o Flow marca os pedidos que vieram do bloco.
 *
 * Esse quick view tambem sai sem o "Compre ja" (pagamento direto): a peca vai
 * para a sacola junto com a da pagina, e o "Adicionar" fica no estilo primario,
 * como o tema faz quando o quick view nao tem o pagamento direto. O quick view
 * aberto pelos cards continua igual.
 */
if (!customElements.get('bs-compre-junto')) {
  const ORIGEM_NAME = 'properties[_origem]';
  const ORIGEM_VALUE = 'Compre o conjunto';
  let pendingHandle = null;

  // O quick view e do tema e abre para qualquer botao: guarda qual produto foi
  // pedido pelo bloco. Um quick view aberto fora do bloco limpa o pedido.
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.m-product-quickview-button');
      if (!button) return;
      pendingHandle = button.closest('bs-compre-junto') ? button.dataset.productHandle : null;
    },
    true
  );

  document.addEventListener('quick-view:loaded', (event) => {
    const handle = pendingHandle;
    pendingHandle = null;
    if (!handle || !event.detail || event.detail.productUrl !== handle) return;
    const forms = document.querySelectorAll('#MainProduct-quick-view__content form[action*="/cart/add"]');
    const form = forms[forms.length - 1];
    if (!form || form.querySelector(`[name="${ORIGEM_NAME}"]`)) return;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = ORIGEM_NAME;
    input.value = ORIGEM_VALUE;
    form.appendChild(input);

    // Roda no mesmo ciclo em que o modal abre, antes da pintura: nao pisca.
    const buyNow = form.querySelector('.m-product-dynamic-checkout');
    if (buyNow) {
      buyNow.remove();
      const addButton = form.querySelector('button[name="add"]');
      if (addButton) addButton.classList.replace('m-button--secondary', 'm-button--primary');
    }
  });

  class BsCompreJunto extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-bs-compre-junto-list]');
      this.limit = parseInt(this.dataset.limit, 10) || 2;
      this.fill().finally(() => {
        this.hidden = this.items().length === 0;
      });
    }

    items() {
      return Array.from(this.list.querySelectorAll('[data-bs-compre-junto-item]'));
    }

    async fill() {
      for (const intent of ['complementary', 'related']) {
        const missing = this.limit - this.items().length;
        if (missing <= 0) return;
        try {
          const response = await fetch(`${this.dataset.url}&limit=${this.limit + 2}&intent=${intent}`);
          if (!response.ok) continue;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const shown = new Set(this.items().map((item) => item.dataset.bsCompreJuntoItem));
          Array.from(html.querySelectorAll('[data-bs-compre-junto-item]'))
            .filter((item) => !shown.has(item.dataset.bsCompreJuntoItem))
            .slice(0, missing)
            .forEach((item) => this.list.appendChild(this.label(item)));
        } catch (error) {
          // Sem recomendacao nao e erro de pagina: fica o que o metacampo trouxe.
        }
      }
    }

    // A section da API nao conhece as settings do bloco: o texto do botao vem daqui.
    label(item) {
      const label = this.dataset.buttonLabel || '';
      const button = item.querySelector('.bs-compre-junto__button');
      const title = item.querySelector('.bs-compre-junto__title');
      item.querySelector('.bs-compre-junto__button-label').textContent = label;
      if (button && title) button.setAttribute('aria-label', `${label}: ${title.textContent.trim()}`);
      return item;
    }
  }

  customElements.define('bs-compre-junto', BsCompreJunto);
}
